import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    all (request) {
      const uri = `infections/${request.inf}`
      return api.post(uri, request)
    },
    transform (request) {
      const uri = `transform/${request.inf}`
      return api.post(uri, request)
    },
    fromVersion (request) {
      const uri = `infections/fromversion/${request.inf}`
      return api.post(uri, request)
    }
  }
} else {
  module = {

    all (request) {
      return delay(1500)({
        data: {
          err: 'Erreur au chargement des fiches.'
        }
      })
    }
  }
}

export default module
